import React from "react";
// nodejs library that concatenates classes
import Loader from "../../components/Loader/Loader";
export default function RegularButton(props) {
  const {
    color,
    round,
    children,
    disabled,
    simple,
    size,
    block,
    link,
    icon,
    title,
    loader,
    classes,
    toggle,
    toggleTarget,
    btnWrapperClass,
    ...rest
  } = props;
  let iconHolder = null;
  if (icon) {
    iconHolder = <i className={icon} aria-hidden="true"></i>;
  }

  if (!loader) {
    return (
      <div className={btnWrapperClass}>
        <button {...rest} className={classes}>
          {iconHolder} {title}
          {children}
        </button>
      </div>
    );
  } else {
    return <Loader />;
  }
}
